window.Shopify = window.Shopify || {};
window.Shopify.cartPromise = null;

window.Shopify.fetchCart = function() {
    if (window.Shopify.cartPromise) {
        return window.Shopify.cartPromise;
    }
    
    window.Shopify.cartPromise = fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            window.Shopify.cart = cart;
            window.Shopify.cartPromise = null;
            return cart;
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
            window.Shopify.cartPromise = null;
            throw error;
        });
        
    return window.Shopify.cartPromise;
};

window.Shopify.fetchCart()
.then(async cart => {
    document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
                cart: cart,
            }
        })
    );  
})
.catch(error => console.error('Error initializing the cart:', error));
document.addEventListener('line-item:change:end', function (e) {
  console.log("line-item:change:end",e)
  handleCartgiftproductEvent(e)
});
let cartItemAddedTimeout = null;
document.addEventListener('cart:item-added', function (e) {
  if (cartItemAddedTimeout) {
    clearTimeout(cartItemAddedTimeout);
  }
  cartItemAddedTimeout = setTimeout(() => {
    window.Shopify.fetchCart()
    .then(async cart => {
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                    cart: cart,
                }
            })
        );  
    })
  }, 300);
})

// Prevent infinite loops
let isUpdatingGifts = false;
let giftUpdateTimeout = null;

document.addEventListener('cart:refresh', function (e) {
  handleCartgiftproductEvent(e)
})

function handleCartgiftproductEvent(event){
  var cart = event.detail.cart;
  window.Shopify.cart = cart;

  // Early return if cart is empty or gift tiers not configured
  if (!cart || !cart.items || cart.items.length == 0) {
    return;
  }

  if (!window.giftTiers || !window.giftTiers.tiers || window.giftTiers.tiers.length === 0) {
    console.log('No gift tiers configured');
    return;
  }

  // Prevent infinite loop: skip if already updating
  if (isUpdatingGifts) {
    console.log('Gift update in progress, skipping...');
    return;
  }

  // Debounce: clear previous timeout
  if (giftUpdateTimeout) {
    clearTimeout(giftUpdateTimeout);
  }

  // Debounce: wait 500ms before processing
  giftUpdateTimeout = setTimeout(() => {
    processGiftTiers(cart);
  }, 500);
}

function processGiftTiers(cart) {
  console.log("Processing gift tiers for cart:", cart);

  // Step 1: Identify all gifts in cart
  const giftsInCart = identifyGiftsInCart(cart);

  // Step 2: Calculate cart total excluding gifts
  const cartTotalExcludingGifts = calculateCartTotalExcludingGifts(cart, giftsInCart);

  // Step 3: Determine which tier should be active
  const activeTier = window.giftTiers.getActiveTier(cartTotalExcludingGifts);

  console.log('Cart total (excl. gifts):', cartTotalExcludingGifts / 100);
  console.log('Active tier:', activeTier ? activeTier.id : 'none');

  // Step 4: Build update operations
  const updates = buildGiftUpdates(giftsInCart, activeTier);

  // Step 5: Execute update if needed
  if (Object.keys(updates).length > 0) {
    console.log('Updating cart with gift changes:', updates);
    executeCartUpdate(updates);
  } else {
    console.log('No gift updates needed');
  }
}

// Helper: Identify all gifts currently in cart
function identifyGiftsInCart(cart) {
  const giftsInCart = {
    hasAnyGift: false,
    giftsByTier: {}, // { tierId: [variantIds] }
    totalGiftCount: 0,
    giftVariantIds: []
  };

  cart.items.forEach(item => {
    if (window.giftTiers.isGiftProduct(item.product_id)) {
      giftsInCart.hasAnyGift = true;
      giftsInCart.totalGiftCount += item.quantity;
      giftsInCart.giftVariantIds.push(item.id);

      // Find which tier this gift belongs to
      const tier = window.giftTiers.tiers.find(t => t.productId === item.product_id);
      if (tier) {
        if (!giftsInCart.giftsByTier[tier.id]) {
          giftsInCart.giftsByTier[tier.id] = [];
        }
        giftsInCart.giftsByTier[tier.id].push({
          variantId: item.id,
          quantity: item.quantity
        });
      }
    }
  });

  return giftsInCart;
}

// Helper: Calculate cart total excluding gift prices
function calculateCartTotalExcludingGifts(cart, giftsInCart) {
  let giftPriceTotal = 0;

  cart.items.forEach(item => {
    if (window.giftTiers.isGiftProduct(item.product_id)) {
      giftPriceTotal += item.final_line_price;
    }
  });

  return cart.total_price - giftPriceTotal;
}

// Helper: Build gift update operations
function buildGiftUpdates(giftsInCart, activeTier) {
  const updates = {};

  // Case 1: No tier reached - remove all gifts
  if (!activeTier) {
    if (!giftsInCart.hasAnyGift) {
      console.log('No tier reached, but no gifts exist in cart. Skipping API call.');
      return updates;
    }
    
    // Only zero out the gift variants actually in the cart
    giftsInCart.giftVariantIds.forEach(variantId => {
      updates[variantId] = 0;
    });
    console.log('No tier reached, removing existing gifts', updates);
    return updates;
  }

  // Case 2: A tier is reached - ensure only the correct gift exists
  const shouldHaveVariantId = activeTier.variantId;

  // Check if we already have the correct gift with quantity 1
  const hasCorrectGift = giftsInCart.giftsByTier[activeTier.id] &&
                         giftsInCart.giftsByTier[activeTier.id].some(g =>
                           g.variantId == shouldHaveVariantId && g.quantity === 1
                         );

  const onlyHasCorrectGift = hasCorrectGift &&
                             Object.keys(giftsInCart.giftsByTier).length === 1 &&
                             giftsInCart.giftsByTier[activeTier.id].length === 1;

  if (onlyHasCorrectGift) {
    console.log('Already have correct gift, no update needed');
    return updates; // No update needed
  }

  // Remove all gifts from other tiers
  window.giftTiers.tiers.forEach(tier => {
    if (tier.id !== activeTier.id) {
      tier.variants.forEach(v => {
        updates[v.id] = 0;
      });
    }
  });

  // Remove all variants from active tier except the correct one
  if (activeTier.variants) {
    activeTier.variants.forEach(v => {
      if (v.id != shouldHaveVariantId) {
        updates[v.id] = 0;
      }
    });
  }

  // Ensure the correct gift variant has quantity 1
  updates[shouldHaveVariantId] = 1;

  console.log(`Setting tier ${activeTier.id} gift (variant ${shouldHaveVariantId})`);
  return updates;
}

// Helper: Execute cart update via Shopify API
function executeCartUpdate(updates) {
  // Set flag to prevent re-entry
  isUpdatingGifts = true;

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated successfully');
    window.Shopify.cart = data;

    // Reset flag after a delay to allow UI to settle
    setTimeout(() => {
      isUpdatingGifts = false;
      console.log('Gift update complete, ready for next update');
    }, 1000);

    // Trigger UI refresh (without triggering gift logic again due to flag)
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: data
        }
      })
    );
  })
  .catch((error) => {
    console.error('Error updating gift products:', error);
    // Reset flag on error
    isUpdatingGifts = false;
  });
}
